// src/pages/BundeslandBrandenburg.jsx
import React from "react";
import BundeslandPage from "./BundeslandPage";
import { brandenburg } from "../components/states/brandenburg";

export default function BundeslandBrandenburg() {
  return <BundeslandPage data={brandenburg} />;
}

